import { FC } from 'react';
import { DataGrid, GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Integration } from '@/types/models/Integration';

type TableRow = Integration;

type IntegrationsTableProps = {
  rows: TableRow[];
  selectable?: boolean;
  onSelectedChange?: (selectedElements: number[]) => void;
};

const IntegrationsTable: FC<PropsWithClassName<IntegrationsTableProps>> = ({
  rows,
  className,
  onSelectedChange,
  selectable = false,
}) => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    { field: 'id', headerName: t('tableLabel.id'), width: 100 },
    {
      field: 'restaurant_id',
      headerName: t('tableLabel.restaurant'),
      width: 300,
      valueGetter: (row) => (row as Integration['restaurant_id']).name,
    },
    { field: 'platform_name', headerName: t('tableLabel.platform_name'), width: 200 },
    {
      field: 'created_at',
      headerName: t('tableLabel.created_at'),
      width: 200,
      cellClassName: 'flex items-center',
      renderCell: (params) => dayjs(params.row.created_at).format('h:mm a | MM/DD/YY'),
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  return (
    <Paper sx={{ width: '100%' }} className={className}>
      <DataGrid
        getRowId={(row) => row.id}
        rows={rows}
        columns={columns}
        checkboxSelection={selectable}
        onRowSelectionModelChange={(selectedIds: GridRowSelectionModel) => {
          if (onSelectedChange) {
            onSelectedChange(selectedIds.map((id) => id as number) ?? []);
          }
        }}
        disableMultipleRowSelection={true}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 20, 50, 100]}
        rowSelection={selectable}
        disableRowSelectionOnClick={true}
      />
    </Paper>
  );
};

export default IntegrationsTable;
